module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background top-left",
    staticStyle: {
      "z-index": "10",
      "display": "none"
    },
    attrs: {
      "id": "videoPlayer-container"
    },
    on: {
      "mouseout": _vm.handleMouseOut,
      "mousemove": _vm.handleMouseMove
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customControl),
      expression: "customControl"
    }],
    attrs: {
      "id": "bg-mask-popup-video-player"
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "video_player background",
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "id": "popup-video-player",
      "width": "100%",
      "controls": "",
      "controlsList": "nodownload nofullscreen",
      "playsinline": ""
    },
    on: {
      "click": _vm.handlePlayPause
    }
  }, [_c('source', {
    attrs: {
      "id": "popup-video-player-src",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-button bk-menu-icon",
    staticStyle: {
      "z-index": "20"
    },
    attrs: {
      "id": "close-video-btn"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('video-controls', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customControl),
      expression: "customControl"
    }],
    ref: "controls",
    attrs: {
      "videoId": 'popup-video-player'
    },
    on: {
      "hide-vid-controls": _vm.handleHideControl,
      "show-vid-controls": _vm.handleShowControl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11eb516e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video-Player.vue
// module id = 220
// module chunks = 1